<template>
  <require from="components/filters/locations-map-filter"></require>
  <require from="components/mobile_app_dashboard/installations-box"></require>
  <require from="components/mobile_app_dashboard/active-users-box"></require>
  <require from="components/mobile_app_dashboard/tracking-users-box"></require>
  <require from="components/mobile_app_dashboard/panic-alerts-box"></require>
  <require from="components/mobile_app_dashboard/users-locations-box"></require>
  <require from="components/mobile_app_dashboard/locations-chart-box"></require>
  <require from="components/mobile_app_dashboard/events-list"></require>
  <require from="leaflet/dist/leaflet.css"></require>
  <require from="leaflet.markercluster/dist/MarkerCluster.css"></require>
  <require from="leaflet.markercluster/dist/MarkerCluster.Default.css"></require>

  <div class="leaflet-control leaflet-bar map-control" ref="filterBox">
    <locations-map-filter class="map-filter" model.bind="filter" mutated.call="filterMutated()"></locations-map-filter>
  </div>
  <div class="leaflet-control leaflet-bar map-control d-none d-sm-block" ref="installationsBox">
    <installations-box data.bind="dashboardData.installedVersions"></installations-box>
  </div>
  <div class="leaflet-control leaflet-bar map-control d-none d-sm-block" ref="activeUsersBox">
    <active-users-box data.bind="dashboardData.activeUsers"></active-users-box>
  </div>
  <div class="leaflet-control leaflet-bar map-control d-none d-sm-block" ref="trackingUsersBox">
    <tracking-users-box data.bind="dashboardData.trackingUsers"></tracking-users-box>
  </div>
  <div class="leaflet-control leaflet-bar map-control" ref="panicAlertsBox">
    <panic-alerts-box data.bind="dashboardData.panicRequests" show-panic-request.call="showPanicRequest(panicRequest)"></panic-alerts-box>
  </div>
  <div class="leaflet-control leaflet-bar map-control d-none d-sm-block" ref="usersLocationsBox">
    <users-locations-box data.bind="dashboardData.countryUsersCounts"></users-locations-box>
  </div>
  <div class="leaflet-control leaflet-bar map-control d-none d-sm-block" ref="locationsChartBox">
    <locations-chart-box model.bind="dashboardData.trackingHourly"></locations-chart-box>
  </div>
  <div class="leaflet-control map-control events-list-control d-none d-sm-block" ref="eventsList">
    <events-list delayed-panic-requests.bind="dashboardData.delayedPanicRequests" events.bind="dashboardData.mobileAppEvents"></events-list>
  </div>
  <div class="locations-map-wrapper">
    <div show.bind="!dashboardData.usersLatestLocations" class="locations-map-overlay">
      <div title="loading" class="locations-map-spinner"><i class="fas fa-spinner sc-spin"></i></div>
    </div>
    <div id="locationsMap" ref="locationsMapPlaceholder">
    </div>
  </div>
</template>